import styled from 'foundations-theming/utils';
import { useMemo } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import ILSListPreviewLink from 'automation-ui-enrollment/components/common/ILSListPreviewLink';
import ListCountFromMode, { getEnrollModeHasFilters } from 'automation-ui-enrollment/components/enrollment/manual/ListCountFromMode';
import { isCustomObject } from 'automation-ui-references/object-types/objectTypeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledLabelContainer = styled.div.withConfig({
  displayName: "EnrollCountStatusBar__StyledLabelContainer",
  componentId: "vaf536-0"
})(["font-size:16px;"]);
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "EnrollCountStatusBar__StyledUIFlex",
  componentId: "vaf536-1"
})(["background-color:white;padding:15px 40px;min-height:60px;border-top:1px solid ", ";"], ({
  theme
}) => theme.color['do-not-use-battleship']);
const EnrollCountStatusBar = ({
  objectTypeId,
  objectCount,
  listId,
  filterBranch,
  handleOpenPreviewPanel,
  enrollMode,
  flow,
  updateFilterCache,
  filterCache
}) => {
  const serializedFilterBranch = useMemo(() => JSON.stringify(filterBranch), [filterBranch]);
  const listIdCached = filterCache.get(serializedFilterBranch);
  return /*#__PURE__*/_jsxs(StyledUIFlex, {
    align: "center",
    justify: "between",
    children: [/*#__PURE__*/_jsx(StyledLabelContainer, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.number_jsx",
        elements: {
          b: 'b'
        },
        options: {
          listCount: /*#__PURE__*/_jsx(ListCountFromMode, {
            enrollMode: enrollMode,
            objectTypeId: objectTypeId,
            listId: listId || listIdCached,
            filterBranch: filterBranch,
            objectCount: objectCount
          }),
          objectTypeNamePlural: /*#__PURE__*/_jsx(ObjectTypeName, {
            isCapitalized: true,
            isPlural: true,
            objectTypeId: objectTypeId
          })
        }
      })
    }), (listId && !isCustomObject(objectTypeId) || objectCount > 0) && !getEnrollModeHasFilters(enrollMode) && /*#__PURE__*/_jsxs(UIButton, {
      use: "link",
      onClick: () => handleOpenPreviewPanel(),
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "viewDetails"
      }), /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.link_cob",
        objectTypeId: objectTypeId
      })]
    }), getEnrollModeHasFilters(enrollMode) && (listIdCached ? /*#__PURE__*/_jsxs(UIButton, {
      use: "link",
      onClick: () => handleOpenPreviewPanel(listIdCached),
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "viewDetails"
      }), /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.link_cob",
        objectTypeId: objectTypeId
      })]
    }) : /*#__PURE__*/_jsx(ILSListPreviewLink, {
      objectTypeId: objectTypeId,
      filterBranch: filterBranch,
      workflowName: flow.name,
      listCreatedCallback: listReferenceId => {
        handleOpenPreviewPanel(listReferenceId);
        updateFilterCache(serializedFilterBranch, listReferenceId);
      },
      linkLabel: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "viewDetails"
        }), /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.link_cob",
          objectTypeId: objectTypeId
        })]
      }),
      isExternalLink: false
    }))]
  });
};
export default EnrollCountStatusBar;